import React from "react";
import { CheckCircle2 } from "lucide-react";
import { StatusCard } from "./PageShells";

const SuccessPage = () => (
  <div className="min-h-[70vh] bg-gradient-to-b from-slate-50 to-emerald-50/40 px-4 py-16 sm:py-24">
    <StatusCard
      icon={CheckCircle2}
      tone="green"
      eyebrow="Payment confirmed"
      title="Payment Successful!"
      primary={{ to: "/upload", label: "Continue to JobZam" }}
      secondary={{ to: "/", label: "Return to Home" }}
    >
      <p>Thank you for upgrading to JobZam Premium. You now have unlimited access!</p>
    </StatusCard>
  </div>
);

export default SuccessPage;
